import React, { Component } from 'react';
import Rating from '@material-ui/lab/Rating';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { itemService, globalService as gs } from '../../../common/services';
import { alertSelectors } from '../../../common/redux/selectors';
import moment from 'moment-timezone';
import Pagination from '@material-ui/lab/Pagination';
import RatingReplyFormDialog from './RatingReplyFormDialog';

class RatingListings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            params: {
                item_id: '',
                user_id: '',
                page: null
            },
            ratings: null,
            pagination: null,
            loading: false,
            open: false,
            itemData: null,
        };
    }

    componentDidMount() {
        const { match } = this.props;
        const item_id = match && match.params.id;
        let params = {...this.state.params};
        //params['item_id'] = item_id;
        params['user_id'] = item_id;
        this.setState({params}, () => this.loadRatings());
    }

    loadRatings = (loading = true) => {
        const { dispatch } = this.props;
        this.setState({loading});
        itemService.review("GET", null, this.state.params).then(data => {
            const ratings = data.items;
            const pagination = data.pagination;
            this.setState({ratings, pagination, loading: false});
        })
        .catch(exception => {
            gs.showErrors(dispatch, exception, alertSelectors);
            this.setState({loading: false});
        });
    }

    onChangePage = (event, page) => {
        const params = { ...this.state.params };
        params['page'] = page;
        this.setState({ params }, () => this.loadRatings());
    }

    onReply = (itemData) => {
        this.setState({itemData, open: true});
    }

    handleClose = (loading) => {
        if(loading) {
            this.setState({itemData: null, open: false});
            this.loadRatings(loading);
        } else {
            this.setState({itemData: null, open: false});
        }
    }

    render() {
        const { authentication, productData, loading } = this.props;
        const user = authentication && authentication.authentication && authentication.authentication.user;
        const { ratings, pagination, open, itemData } = this.state;
        //console.log('user', Math.floor(productData && productData.avg_rating));
        return (<>
            <RatingReplyFormDialog open={open} onClose={this.handleClose} itemData={itemData} />
            <div className="rating-review detail">
                <div className="heading">
                    <div className="d-flex flex-wrap">
                        <div className="text-primary sub-title"> Ratings & Reviews</div> 
                        <div className="rating ml-lg-5 ml-sm-3">
                            <span className="star">
                                <Rating name="size-medium" value={Math.floor(productData && productData.avg_rating)} readOnly />
                            </span>
                            <span className="name"> ({productData && productData.avg_rating}) {productData && productData.ratings} Ratings</span>
                        </div>
                    </div> 
                </div> 
                <ul className="review-list list-group">
                    {loading ?
                    'Loading..' : <>
                    {ratings && ratings.map((item) =>
                        <li key={`main-${item.id}`} className="list-group-item">
                            <div className="d-flex left-site">
                                <div className="pic mr-3">
                                    <img className="rounded-circle" src={item.reviewBy && item.reviewBy.avatar && item.reviewBy.avatar.thumb} alt=""/>
                                </div>
                                <div className="text">
                                    <h5>{item.reviewBy.name}</h5>
                                    <p className="text-center text">{moment(item.created_at * 1000).format('LL')}</p>   
                                </div>
                            </div>
                            <div className="right-site">
                                <p className="text">"{item.review}"
                                </p>
                                {((!item.reply) && (user && user.user_id === item.replyBy.user_id)) &&
                                <div className="reply text-right">
                                    <button className="btn btn-link" onClick={() => this.onReply(item)}>Reply</button>
                                </div>}
                            </div>

                            {(item.reply) && 
                            <ul>
                                <li>
                                    <div className="rating-list">
                                        <div className="caption">
                                            <div className="text">
                                                {item.reply}
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>}
                        </li>
                    )}
                    {(ratings && ratings.length === 0) && <li className="list-group-item">Rating not found </li> }
                    </>}
                </ul>
                {pagination && pagination.totalCount > 19 && 
                    <div className="text-center load py-5">
                        <Pagination count={Math.ceil(parseInt(pagination && pagination.totalCount) / 20)} defaultPage={1} siblingCount={0} size="large" color="primary" onChange={this.onChangePage} />
                    </div>
                }
            </div>
        </>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    (process, authentication) => ({
        process, authentication
    })
);

export default connect(mapStateToProps)(RatingListings);